<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.role')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="roleParams.name"
                  value="roleParams.name"
                  :label="$t('forms.inputs.role')"
                >
                </va-input>
              </div>

            </div>

          <div class="row">
            <div class="flex md2 sm6 xs12">
              <va-button
                v-if="roleParams.roleId == ''"
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="create(roleParams)"
              >
                {{ $t('menu.save') }}
              </va-button>
              <va-button
                v-else
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="update(roleParams)"
              >
                {{ $t('menu.update') }}
              </va-button>
            </div>
            <div class="flex md2 sm6 xs12">
              <va-button
                medium
                inline
                color="#ff842b"
                icon="fa fa-chevron-left"
                class="ma-0"
                  :to="{ name: 'roles', params: {
                    current_page: this.$route.params.current_page, 
                    searchName: this.$route.params.searchName, 
                    perPage: this.$route.params.perPage }
                    }"
              >
                {{ $t('menu.back') }}
              </va-button>
            </div>
          </div>

          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import RoleAPI from '@/services/RoleAPI'
import { showError } from '@/global'

export default {
  name: 'form-packages',
  components: {},
  data () {
    return {
      roleParams: {
        roleId: '',
        name: ''
      },
    }
  },
  mounted () {
    if (this.$route.params.id != undefined) {
      RoleAPI.getRoleById(this.$route.params.id).then(response => {
        this.roleParams = response.data.role
      })
    }
  },
  computed: {
  },
  methods: {
    create (roleParams) {
      RoleAPI.createRole(roleParams).then(response => {
        this.package = response.data;

          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          }),
          
        this.$router.push('/admin/tables/roles')

      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    update (roleParams) {
      RoleAPI.updateRole(roleParams).then(response => {
        self.data = response.data;

          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          }),
          
        this.$router.push('/admin/tables/roles')
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
  }
}
</script>